<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'COMPANY_PROFILE.TITLE' | translate }}
    </glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="'ADMINISTRATION.PAGE_TITLE' | translate"
        [previousPageUrl]="'/settings'"
        [useHistory]="true"
        [historyBackButtonTitle]="'COMMON.ACTION_LABELS.BACK' | translate"
      ></glxy-page-nav-button>
    </glxy-page-nav>
  </glxy-page-toolbar>
  <div class="card-wrapper">
    <mat-card appearance="outlined" class="company-card">
      @if (partnerMailingAddressInfo$ | async) {
        <mat-card-content>
          <form [formGroup]="updateCompanyFormGroup">
            <glxy-form-field class="form-input" [required]="true">
              <glxy-label>{{ 'COMPANY_PROFILE.COMPANY_NAME' | translate }}</glxy-label>
              <input matInput [formControl]="updateCompanyFormGroup.controls.company_name" />
            </glxy-form-field>
            <glxy-phone-input
              class="form-input"
              [formControl]="updateCompanyFormGroup.controls.phone_number"
              [placeholder]="'COMPANY_PROFILE.PHONE_NUMBER' | translate"
              [required]="false"
            ></glxy-phone-input>
            <glxy-form-field class="form-input">
              <glxy-label>{{ 'COMPANY_PROFILE.WEBSITE_URL' | translate }}</glxy-label>
              <input matInput [formControl]="updateCompanyFormGroup.controls.website_address" />
            </glxy-form-field>
            <glxy-form-field class="form-input">
              <glxy-label>{{ 'COMPANY_PROFILE.EMAIL_ADDRESS' | translate }}</glxy-label>
              <input
                matInput
                type="email"
                [formControl]="updateCompanyFormGroup.controls.email_address"
                [placeholder]="'COMPANY_PROFILE.EMAIL_ADDRESS' | translate"
              />
              @if (updateCompanyFormGroup.controls.email_address.hasError('email')) {
                <glxy-error>{{ 'GALAXY.INPUT.EMAIL.VALIDATION_ERROR' | translate }}</glxy-error>
              }
            </glxy-form-field>
            <!-- ADDRESS SECTION -->
            <div class="address-section-title">
              <strong>
                {{ 'COMPANY_PROFILE.ADDRESS_TITLE' | translate }}
              </strong>
            </div>
            @if (countryOptions$ && (countryOptions$ | async)?.length > 0) {
              <glxy-form-field class="form-input">
                <glxy-label>{{ 'COMMON.ADDRESS.COUNTRY' | translate }}</glxy-label>
                <mat-select [formControl]="updateCompanyFormGroup.controls['country']" [required]="true">
                  @for (option of countryOptions$ | async; track option.value) {
                    <mat-option [value]="option.value" [disabled]="option.disabled">
                      {{ option.label }}
                    </mat-option>
                  }
                </mat-select>
              </glxy-form-field>
            }
            <glxy-form-field class="form-input" [required]="true">
              <glxy-label>{{ 'COMMON.ADDRESS.LINE_1' | translate }}</glxy-label>
              <input matInput [formControl]="updateCompanyFormGroup.controls['address']" />
            </glxy-form-field>
            <glxy-form-field class="form-input">
              <glxy-label>{{ 'COMMON.ADDRESS.LINE_2' | translate }}</glxy-label>
              <input matInput [formControl]="updateCompanyFormGroup.controls['additionalAddressLine']" />
            </glxy-form-field>
            @if ((stateProvOptions$$ | async)?.length > 0) {
              <glxy-form-field class="form-input">
                <glxy-label>{{ 'COMMON.ADDRESS.STATE_PROV' | translate }}</glxy-label>
                <mat-select [formControl]="updateCompanyFormGroup.controls['stateProv']" [required]="true">
                  @for (option of stateProvOptions$$ | async; track option.value) {
                    <mat-option [value]="option.value" [disabled]="option.disabled">
                      {{ option.label }}
                    </mat-option>
                  }
                </mat-select>
              </glxy-form-field>
            }
            <glxy-form-field class="form-input" [required]="true">
              <glxy-label>{{ 'COMMON.ADDRESS.CITY' | translate }}</glxy-label>
              <input matInput [formControl]="updateCompanyFormGroup.controls['city']" />
            </glxy-form-field>
            <glxy-form-field class="form-input" [required]="true">
              <glxy-label>{{ 'COMMON.ADDRESS.POSTAL_CODE' | translate }}</glxy-label>
              <input matInput [formControl]="updateCompanyFormGroup.controls['postalCode']" />
            </glxy-form-field>
          </form>
          <!-- END ADDRESS SECTION -->
          <mat-card-actions>
            <button mat-flat-button color="primary" (click)="updateCompanyProfile()" [disabled]="isUpdatingProfile">
              @if (!isUpdatingProfile) {
                {{ 'COMMON.ACTION_LABELS.SAVE' | translate }}
              } @else {
                <div class="loading-spinner">
                  <mat-spinner diameter="36"></mat-spinner>
                </div>
              }
            </button>
          </mat-card-actions>
        </mat-card-content>
      } @else {
        <div class="loading-page-spinner">
          <mat-spinner diameter="45"></mat-spinner>
        </div>
      }
    </mat-card>
  </div>
</glxy-page>
